export default "__VITE_ASSET__Dh8WLaX$__"